import { createStore } from 'vuex'
import subtitle from './modules/subtitle'

export default createStore({
  modules: {
    subtitle
  }
})
